import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/seo/SEOHead';
import { getLocalBusinessSchema, getBreadcrumbSchema } from '../../utils/structuredData';
import { getImageUrl } from '../../utils/seo';

export default function Iletisim() {
  const breadcrumbItems = [
    { name: 'Anasayfa', url: '/' },
    { name: 'İletişim', url: '/iletisim' }
  ];

  const structuredData = [
    getLocalBusinessSchema(),
    getBreadcrumbSchema(breadcrumbItems)
  ];

  return (
    <div className="bg-[#1c1612] min-h-screen">
      <SEOHead
        title="İletişim | Studio Asım Mete | İç Mimari Tasarım İstanbul"
        description="Studio Asım Mete ile iletişime geçin. İstanbul Sarıyer'de bulunan stüdyomuz. Telefon: +90 537 961 99 20. İç mimari projeleriniz için ücretsiz ilk görüşme."
        keywords="studio asım mete iletişim, iç mimar iletişim istanbul, mimari tasarım danışmanlığı, ücretsiz görüşme, sarıyer iç mimar"
        canonical="/iletisim"
        structuredData={structuredData}
      />
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden -mt-20 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('${getImageUrl('/sam-daire/hero.jpg')}')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-[#0e0c0a]/80 via-[#0e0c0a]/70 to-[#0e0c0a]/80"></div>
        </div>
        
        <div className="relative z-[60] text-center px-6">
          <h1 className="text-6xl md:text-7xl font-light text-white tracking-wider mb-4 font-serif">
            Yeni Bir Projeniz Mi Var?
          </h1>
          <p className="text-xl text-white font-light font-serif mt-8">
            Projeniz için bizimle iletişime geçin
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-32 px-6 bg-[#0e0c0a]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-light text-white tracking-wider mb-12 font-serif">
            Bize Ulaşın
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="flex items-start">
              <div className="w-12 h-12 flex items-center justify-center mr-6 border border-[#3d3020] rounded-sm flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-light text-white tracking-wide mb-2 font-serif">
                  Adres
                </h3>
                <p className="text-white font-light leading-relaxed font-sans text-sm">
                  4. Levent Otosanayi Sitesi<br />
                  Barbaros Cd No:4<br />
                  Sarıyer, İstanbul
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-12 h-12 flex items-center justify-center mr-6 border border-[#3d3020] rounded-sm flex-shrink-0">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-light text-white tracking-wide mb-2 font-serif">
                  Telefon
                </h3>
                <p className="text-white font-light font-sans text-sm">
                  +90 537 961 99 20
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-12 h-12 flex items-center justify-center mr-6 border border-[#3d3020] rounded-sm flex-shrink-0">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-light text-white tracking-wide mb-2 font-serif">
                  Çalışma Saatleri
                </h3>
                <p className="text-white font-light font-sans text-sm">
                  Pazartesi - Cuma: 09:00 - 18:00<br />
                  Cumartesi: 10:00 - 15:00
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="h-[500px] bg-[#1c1612]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.3936094583!2d29.004297!3d41.094615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDA1JzQwLjYiTiAyOcKwMDAnMTUuNSJF!5e0!3m2!1str!2str!4v1234567890&q=41.094615,29.004297"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Studio Asım Mete Konum"
        ></iframe>
      </section>

      <Footer />
    </div>
  );
}